class Banner extends HTMLElement {
  constructor() {
    super();
    // Solo inicializamos la clave de almacenamiento en el constructor
    this.storageKey = ''; // Se inicializa correctamente en connectedCallback
  }

  get closeButton() {
    return this.querySelector('[data-trigger=close]');
  }

  /**
   * Verifica si el banner debe mostrarse y gestiona su visibilidad
   */
  handleDefaultVisibility() {
    const closedData = this.getClosedData();

    if (closedData) {
      // Si está configurado para nunca mostrar de nuevo
      if (closedData.expirationDays === 0) {
        this.hideBanner();
        return;
      }

      // Verificamos si ya pasó el tiempo de expiración
      const closedTime = new Date(closedData.timestamp);
      const currentTime = new Date();
      const diffTime = currentTime - closedTime;
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      if (diffDays < closedData.expirationDays) {
        // No ha expirado, mantenemos oculto
        this.hideBanner();
      } else {
        // Ya expiró, mostramos el banner
        this.showBanner();
        this.removeClosedData();
      }
    } else {
      // Si no hay datos de cierre, mostramos el banner
      this.showBanner();
    }
  }

  /**
   * Guarda en localStorage la información de cuándo se cerró el banner
   */
  saveClosedData() {
    const data = {
      timestamp: new Date().toISOString(),
      expirationDays: this.expirationDays, // Guardamos también los días de expiración
    };
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  /**
   * Recupera la información guardada del cierre del banner
   */
  getClosedData() {
    const data = localStorage.getItem(this.storageKey);
    return data ? JSON.parse(data) : null;
  }

  /**
   * Elimina la información guardada del cierre del banner
   */
  removeClosedData() {
    localStorage.removeItem(this.storageKey);
  }

  hideBanner() {
    this.classList.add('hidden');
  }

  showBanner() {
    this.classList.remove('hidden');
  }

  handleCloseButton(e) {
    this.hideBanner();

    // Guardamos la información del cierre
    this.saveClosedData();
  }

  connectedCallback() {
    // Inicializamos el ID para la clave de almacenamiento
    if (this.id) {
      this.storageKey = `banner-${this.id}-closed`;
    }

    // Convertimos el atributo expiration-days a número
    this.expirationDays = 0; // Valor por defecto: nunca mostrar de nuevo
    if (this.hasAttribute('expiration-days')) {
      this.expirationDays = parseInt(this.getAttribute('expiration-days'), 10) || 0;
    }

    this.bind();
    this.handleDefaultVisibility();
  }

  bind() {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', e => this.handleCloseButton(e));
    }
  }
}

customElements.define('c-banner', Banner);